module.exports = __webpack_public_path__ + "img/medal.d2b03beb.webp";